export default {
  edit: { lazy: () => import('./ContentEdit') },
  options: {
    edit: {
      title: 'Business Information',
      subtitle: 'Provide key information about your business that will be included in your custom proposal.',
      breadCrumb: 'Business Information',
    },
  },
}
